import { ButtonGroup, Icon, IconButton } from "@mui/material";

type Props = {
    onCommand: (command: string) => void;
};

const ActionButtons = ({ onCommand }: Props) => (
    <ButtonGroup disableElevation color="inherit" variant="contained" size="small">
        <IconButton title="Undo" color="inherit" onClick={() => onCommand('undo')}>
            <Icon>undo</Icon>
        </IconButton>
        <IconButton title="Redo" color="inherit" onClick={() => onCommand('redo')}>
            <Icon>redo</Icon>
        </IconButton>
        <IconButton title="Delete" color="inherit" onClick={() => onCommand('delete')}>
            <Icon>backspace</Icon>
        </IconButton>
    </ButtonGroup>
);

export default ActionButtons;
